import { render, staticRenderFns } from "./PrihatinStat.vue?vue&type=template&id=39c324ce&"
import script from "./PrihatinStat.vue?vue&type=script&lang=js&"
export * from "./PrihatinStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports